import React from "react";
import { useConsolidatedPaymentPrefContext } from "../../Context";
import { ExistingPaymentPrefDisplayCard } from "../ExistingPaymentPrefDisplayCard";
import { PreviewPaymentPrefDisplayCard } from "../PreviewPaymentPrefDisplayCard";

/**
 * Card component for displaying payment preference information in confirmation scenarios.
 *
 * This component automatically selects between PreviewPaymentPrefDisplayCard and
 * ExistingPaymentPrefDisplayCard based on the context state. For advanced features
 * like accessory content, field visibility configuration, and default expanded state,
 * use the Display components directly.
 *
 * @example
 * ```tsx
 * // Basic confirmation display
 * <PaymentPrefConfirmationDisplayCard />
 * ```
 */
export const PaymentPrefConfirmationDisplayCard: React.FC = () => {
  const { paymentPrefDetail, selectedPaymentPref } = useConsolidatedPaymentPrefContext();

  let paymentPrefDisplay = null;
  if (paymentPrefDetail) {
    paymentPrefDisplay = <PreviewPaymentPrefDisplayCard paymentPref={paymentPrefDetail} />;
  } else if (selectedPaymentPref) {
    paymentPrefDisplay = (
      <ExistingPaymentPrefDisplayCard paymentPref={selectedPaymentPref} displayRevealDetails />
    );
  }

  return paymentPrefDisplay;
};
